import { CurrentPayment, PaymentOrigin } from 'Invoices/types'

export const toCurrentPaymentOrigin = (
  origin: CurrentPayment['origin']
): PaymentOrigin | undefined => (origin === 'MANUAL' ? 'SEQUENCE' : origin)
